import { ObjectTools } from '../../tools/object-tools';
import { SolContent } from './sol-content';
import { SolContentMarkdownTools, SolMarkdownFeatures } from '../../tools/sol-content-markdown-tools';
import { NavigationTarget } from '../../tools/router-tools';

export class SolMarkdown {
  private constructor(
    public readonly text: string,
    public readonly assetBasePath: string | undefined,
    public readonly features: Partial<SolMarkdownFeatures> | undefined,
    public readonly linkTarget: NavigationTarget,
    public readonly content: SolContent,
    public readonly html: string,
  ) {}

  public static of(): SolMarkdown {
    return new SolMarkdown('', undefined, undefined, NavigationTarget.SameTab, SolContent.empty(), '');
  }

  public withText(text: string): SolMarkdown {
    if (this.text === text) {
      return this;
    }
    return this.copy({ text }).calculateContent();
  }

  public withAssetBasePath(assetBasePath: string | undefined): SolMarkdown {
    if (this.assetBasePath === assetBasePath) {
      return this;
    }
    return this.copy({ assetBasePath }).calculateContent();
  }

  public withFeatures(features: Partial<SolMarkdownFeatures> | undefined): SolMarkdown {
    if (ObjectTools.equals(this.features, features)) {
      return this;
    }
    return this.copy({ features }).calculateContent();
  }

  public withLinkTarget(linkTarget: NavigationTarget): SolMarkdown {
    if (this.linkTarget === linkTarget) {
      return this;
    }
    return this.copy({ linkTarget });
  }

  private calculateContent(): SolMarkdown {
    return this.copy({
      content: SolContentMarkdownTools.parse(this.text, {
        assetBasePath: this.assetBasePath,
        features: this.features,
      }),
      html: '',
    });
  }

  private copy(props: Partial<SolMarkdown>): SolMarkdown {
    return ObjectTools.copy<SolMarkdown>(this, props);
  }
}
